'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
// import logo from '../../../static/images/logo-blue.svg';

var AppHelmet = function AppHelmet(_ref) {var translate = _ref.translate,locale = _ref.locale;return (
    _react2.default.createElement(_reactHelmet2.default, {
      htmlAttributes: { lang: locale },
      meta: [
      { property: 'og:url', content: _constants.shareUrl },
      { property: 'og:description', content: translate('onMap_description') },
      { property: 'og:image', content: _constants.onMapLogoSocials },
      { property: 'og:image:width', content: '600' },
      { property: 'og:image:height', content: '315' }] }));};




AppHelmet.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string };exports.default =


AppHelmet;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AppHelmet/AppHelmet.js
// module id = 2613
// module chunks = 0